import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import "./Footer.scss";
import i18n from "../../I18n";
import SelectLanguage from "./navigator/SelectLanguage";
import { defaultHeaderConfig, headerConfig } from "frontend_common/HeaderConfig";
import { isMobile } from "utils/ScreenUtils";
import { APP_NAME } from "utils/Config";

const Footer = ({
  language,
}) => {
  const location = useLocation();
  const [navBarConfig, setNavBarConfig] = useState({});
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);

  const isSelectStorePage =
    location.pathname.indexOf("/select_store") !== -1;

  const isHomepage =
    location.pathname.indexOf("/home") !== -1;

  const isOfferPage =
    location.pathname.indexOf("/offer/") !== -1;
  const isUseCashDollarPage =
    location.pathname.indexOf("/use_cash_dollar") !== -1;
  const hideFooter = isSelectStorePage || isUseCashDollarPage

  const footerBackgroundColorG8 = isHomepage || isOfferPage
  const currentYear = new Date().getFullYear();

  const isMobileView = isMobile();

  useEffect(() => {
    let config = defaultHeaderConfig;
    headerConfig.forEach(item => {
      if (location.pathname.indexOf(item.pathname) !== -1) {
        config = item;
      };
    });
    setNavBarConfig(config);
  }, [location]);

  return (
    <>
      {hideFooter ? null : (
        <Container
          className={footerBackgroundColorG8 ? "footer_container background-greyG8" : "footer_container"}
        >
          <footer className="page_footer container">
            <div className="footer_left">
              <Link className="footer_link tag-menu-1" to={{ pathname: `${process.env.REACT_APP_TERM_CONDITIONS_LINK}?lang=${language}` }} target="_blank" rel="noopener noreferrer">
                {i18n.t("sign_up_terms_conditions")}
              </Link>
              <Link className="footer_link tag-menu-1" to={{ pathname: `${process.env.REACT_APP_PRIVACY_LINK}?lang=${language}` }} target="_blank" rel="noopener noreferrer">
                {i18n.t("sign_up_privacy_policy")}
              </Link>
              <label className="copyright tag-menu-1">
              {"Copyright © 2024 EGL Tours Company Ltd. All rights reserved. \n東瀛遊旅行社有限公司 版權所有 | 旅行社牌照號碼：350805 | 香港聯合交易所主板上市：股份代號 6882"}
              </label>
            </div>

            {
              !isMobileView && !navBarConfig.webShowSideMenu && !navBarConfig.webShowLanguage && (
                <SelectLanguage
                  languageDropdownOpen={languageDropdownOpen}
                  setLanguageDropdownOpen={setLanguageDropdownOpen}
                  extraContainerClassName="tag-menu-1"
                />
              )
            }
          </footer>
        </Container>)
      }
    </>
  );
}

const mapStateToProps = (state) => ({
  language: state.users.language,
});

export default connect(mapStateToProps)(Footer);
